import AlexaV3Exception from './AlexaV3Exception';

export default class HourlyDeviceRateLimitExceeded extends AlexaV3Exception {}
